(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eggraw-clean-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eggraw-video-strip')) {
    customElements.define('eggraw-video-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.videos = [...this.querySelectorAll('video')];
        const track = this.querySelector('.eggraw-video-strip__track');
        const reviews = this.querySelector('.eggraw-video-strip__reviews');
        const topics = this.querySelector('.eggraw-video-strip__topics');
        const cards = [...this.querySelectorAll('.eggraw-video-strip__card')];
        const stories = [...this.querySelectorAll('[data-review-topics]')];
        const buttons = [...this.querySelectorAll('[data-topic-filter]')];
        const dots = [...this.querySelectorAll('[data-review-page]')];
        const videoNav = this.querySelector('.eggraw-video-strip__video-nav');
        const arrows = [...this.querySelectorAll('[data-video-direction]')];
        const videoCounter = this.querySelector('[data-video-counter]');
        const status = this.querySelector('[role="status"]');
        const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const updateNav = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          videoNav.hidden = maxScroll < 2;
          arrows[0].disabled = track.scrollLeft < 2;
          arrows[1].disabled = track.scrollLeft >= maxScroll - 2;
          const visibleCards = cards.filter(card => !card.hidden);
          const videoOrigin = visibleCards[0]?.getBoundingClientRect().left || 0;
          const videoIndex = visibleCards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - videoOrigin - track.scrollLeft) < Math.abs(visibleCards[best].getBoundingClientRect().left - videoOrigin - track.scrollLeft) ? i : best, 0);
          const videoNumber = visibleCards.length ? videoIndex + 1 : 0;
          videoCounter.textContent = `${videoNumber} / ${visibleCards.length}`;
          videoCounter.setAttribute('aria-label', videoCounter.dataset.positionTemplate.replace('[number]', videoNumber).replace('[total]', visibleCards.length));
          const visible = stories.filter(story => !story.hidden);
          const origin = visible[0]?.getBoundingClientRect().left || 0;
          const index = visible.reduce((best, story, i) => Math.abs(story.getBoundingClientRect().left - origin - reviews.scrollLeft) < Math.abs(visible[best].getBoundingClientRect().left - origin - reviews.scrollLeft) ? i : best, 0);
          dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        };
        const filter = (topic, announce = true) => {
          this.videos.forEach(video => {
            const played = !video.paused || video.currentTime > 0;
            video.pause();
            if (played) video.load();
            video.controls = false;
            video.parentElement.querySelector('.eggraw-video-strip__play').hidden = false;
          });
          if (topic === 'all') topics.scrollLeft = 0;
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topicFilter === topic)));
          cards.forEach(card => { card.hidden = topic !== 'all' && !(card.dataset.topics || card.dataset.topic || '').split(/\s+/).includes(topic); });
          stories.forEach(story => { story.hidden = !story.dataset.reviewTopics.split(' ').includes(topic); });
          track.dataset.filtered = String(topic !== 'all');
          track.scrollLeft = 0;
          reviews.scrollLeft = 0;
          updateNav();
          if (announce) status.textContent = status.dataset.statusTemplate.replace('[reviews]', stories.filter(story => !story.hidden).length).replace('[videos]', cards.filter(card => !card.hidden).length);
        };
        topics.hidden = false;
        buttons.forEach(button => {
          const topic = button.dataset.topicFilter;
          if (topic !== 'all') button.hidden = !cards.some(card => (card.dataset.topics || card.dataset.topic || '').split(/\s+/).includes(topic));
        });
        topics.dataset.count = String(buttons.filter(button => !button.hidden).length);
        this.querySelector('.eggraw-video-strip__review-nav').hidden = false;
        buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.topicFilter), options));
        dots.forEach(dot => dot.addEventListener('click', () => {
          const visible = stories.filter(story => !story.hidden);
          const story = visible[Number(dot.dataset.reviewPage)];
          if (story) reviews.scrollTo({left: story.getBoundingClientRect().left - visible[0].getBoundingClientRect().left, behavior: motion()});
        }, options));
        arrows.forEach(arrow => arrow.addEventListener('click', () => track.scrollBy({left: Number(arrow.dataset.videoDirection) * track.clientWidth * (window.matchMedia('(max-width: 991px)').matches ? 1 : .8), behavior: motion()}), options));

        track.addEventListener('scroll', updateNav, options);
        reviews.addEventListener('scroll', updateNav, options);
        filter('all', false);
        this.videos.forEach(video => {
          const button = video.parentElement.querySelector('.eggraw-video-strip__play');
          video.setAttribute('aria-label', video.parentElement.getAttribute('aria-label'));
          video.controls = false;
          button.hidden = false;
          button.addEventListener('click', async () => {
            this.videos.forEach(other => { if (other !== video) other.pause(); });
            video.controls = true;
            try { await video.play(); } catch { button.hidden = false; }
          }, options);
          video.addEventListener('play', () => {
            button.hidden = true;
            this.videos.forEach(other => { if (other !== video) other.pause(); });
          }, options);
          video.addEventListener('ended', () => {
            video.controls = false;
            button.hidden = false;
          }, options);
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach(video => video.pause());
        }, options);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
        }, { threshold: 0.15 });
        this.videos.forEach(video => this.observer.observe(video));
        this.resizeObserver = new ResizeObserver(updateNav);
        this.resizeObserver.observe(track);
        this.resizeObserver.observe(reviews);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.events?.abort();
        this.videos?.forEach(video => video.pause());
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
function erInitPortions(root){root.querySelectorAll('[data-er-portion-calculator]').forEach(function(box){if(box.dataset.ready)return;box.dataset.ready='true';var input=box.querySelector('input');var output=box.querySelector('output');input.addEventListener('input',function(){var value=Number(input.value);if(!input.value||value<1||value>50){output.textContent=box.dataset.invalid;return}var ml=value*10;output.textContent=ml.toLocaleString()+' ml · '+Math.round(ml/500*100)+'% '+box.dataset.bottle})})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){erInitPortions(document)})}else{erInitPortions(document)}
document.addEventListener('shopify:section:load',function(e){erInitPortions(e.target)})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
